var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { SimpleInputDialog } from "../SimpleInputDialog";
import { ConfirmationDialog } from "../ConfirmationDialog";
export const ComplexInputDialog = (props) => {
    const { confirmCancelText, ConfirmCancelDialogProps, shouldConfirmCancel, children } = props, simpleInputDialogProps = __rest(props, ["confirmCancelText", "ConfirmCancelDialogProps", "shouldConfirmCancel", "children"]);
    const [isConfirmationOpen, setConfirmationOpen] = useState(false);
    const finalShouldConfirmCancel = shouldConfirmCancel === undefined
        ? !simpleInputDialogProps.PrimaryActionButtonProps.disabled
        : shouldConfirmCancel;
    const handleSecondaryClick = (e) => {
        var _a;
        if (finalShouldConfirmCancel) {
            setConfirmationOpen(true);
        }
        else {
            (_a = simpleInputDialogProps.SecondaryActionButtonProps) === null || _a === void 0 ? void 0 : _a.onClick(e);
        }
    };
    const handleCloseButtonClick = (e) => {
        var _a;
        if (finalShouldConfirmCancel) {
            setConfirmationOpen(true);
        }
        else {
            ((_a = simpleInputDialogProps.CloseIconButtonProps) === null || _a === void 0 ? void 0 : _a.onClick)
                ? simpleInputDialogProps.CloseIconButtonProps.onClick(e)
                : simpleInputDialogProps.SecondaryActionButtonProps.onClick(e);
        }
    };
    const handleClose = (e, reason) => {
        var _a;
        if (finalShouldConfirmCancel) {
            setConfirmationOpen(true);
        }
        else {
            simpleInputDialogProps.onClose
                ? simpleInputDialogProps.onClose(e, reason)
                : ((_a = simpleInputDialogProps.CloseIconButtonProps) === null || _a === void 0 ? void 0 : _a.onClick)
                    ? simpleInputDialogProps.CloseIconButtonProps.onClick(e)
                    : simpleInputDialogProps.SecondaryActionButtonProps.onClick(e);
        }
    };
    const onLeaveConfirmation = (e) => {
        setConfirmationOpen(false);
        simpleInputDialogProps.SecondaryActionButtonProps.onClick(e);
    };
    return (_jsxs(SimpleInputDialog, Object.assign({}, simpleInputDialogProps, { SecondaryActionButtonProps: Object.assign(Object.assign({}, simpleInputDialogProps.SecondaryActionButtonProps), { onClick: handleSecondaryClick }), CloseIconButtonProps: Object.assign(Object.assign({}, simpleInputDialogProps.CloseIconButtonProps), { onClick: handleCloseButtonClick }), onClose: handleClose, children: [children, _jsx(ConfirmationDialog, Object.assign({}, ConfirmCancelDialogProps, { open: isConfirmationOpen, onClose: () => setConfirmationOpen(false), PrimaryActionButtonProps: Object.assign(Object.assign({}, ConfirmCancelDialogProps.PrimaryActionButtonProps), { onClick: onLeaveConfirmation }), SecondaryActionButtonProps: Object.assign(Object.assign({}, ConfirmCancelDialogProps.SecondaryActionButtonProps), { onClick: () => setConfirmationOpen(false) }), children: confirmCancelText }))] })));
};
//# sourceMappingURL=ComplexInputDialog.js.map